import { Icon, Stack, Text, VStack, useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useAppState } from "../../context";
import CART from "../../types/Cart";
import { useLazyQuery } from "@apollo/client";

import MobileProductsDrawer from "../../molecules/MobileProductsDrawer";
import ShoppingCartDrawer from "../ShoppingCartDrawer";
import { navigate } from "gatsby";
import useAuth from "../../useAuth";
import { HiOutlineMenu, MdPerson } from "../../customIcons";

type CartQuery = {
  cart?: any;
};

const BottomNavigation = () => {
  const { onOpen } = useDisclosure();
  const mobileNavbar = useDisclosure();

  const [isProductsHovered, setIsProductsHovered] = useState(false);
  const [isCartHovered, setIsCartHovered] = useState(false);
  //   const [isFavouritesHovered, setIsFavouritesHovered] = useState(false);
  const [isAccountHovered, setIsAccountHovered] = useState(false);

  const { cart, setCart } = useAppState();

  const { loggedIn } = useAuth();

  const [maybeGetCart] = useLazyQuery<CartQuery>(CART, {
    onCompleted: ({ cart }) => {
      setCart(cart);
    },
    fetchPolicy: "network-only",
  });

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (cart || !initialLoad) {
      return;
    }

    setInitialLoad(false);
    maybeGetCart();
  }, [cart, maybeGetCart]);
  return (
    <Stack
      borderTop="1px solid #E1E7EF"
      boxShadow=" 0px -2px 4px 0px rgba(0, 0, 0, 0.05)"
      py="4px"
      px="20px"
      zIndex={1000}
      w="100%"
      position="fixed"
      bottom={0}
      h="64px"
      bg="#fff"
      justifyContent={{ base: "space-between", sm: "space-evenly" }}
      flexDir="row"
      alignItems="center"
      mx="auto"
    >
      <VStack
        onMouseEnter={() => setIsProductsHovered(true)}
        onMouseLeave={() => setIsProductsHovered(false)}
        cursor="pointer"
        gap={0}
        alignItems="center"
        onClick={
          mobileNavbar.isOpen ? mobileNavbar.onClose : mobileNavbar.onOpen
        }
      >
        <Icon
          width="24px"
          height="24px"
          color={isProductsHovered ? "#CB809E" : "#728197"}
          onClick={onOpen}
          aria-label="Call Sage"
          as={HiOutlineMenu}
        />

        <Text
          color={isProductsHovered ? "#CB809E" : "#728197"}
          textAlign="center"
          fontSize="14px"
        >
          Products
        </Text>
      </VStack>

      <MobileProductsDrawer
        isOpen={mobileNavbar.isOpen}
        onClose={mobileNavbar.onClose}
      />

      <VStack
        mt={2}
        onMouseEnter={() => setIsCartHovered(true)}
        onMouseLeave={() => setIsCartHovered(false)}
        position="relative"
        cursor="pointer"
        alignItems="center"
        gap={0}
      >
        <ShoppingCartDrawer
          isSmallResolutionDrawer
          width="24px"
          iconColor={isCartHovered ? "#CB809E" : "#728197"}
          height="24px"
          hoverBg="transparent"
          placement="bottom"
          callOnClose={() => setIsCartHovered(false)}
        />
        <Text
          textAlign="center"
          fontSize="14px"
          color={isCartHovered ? "#CB809E" : "#728197"}
        >
          Cart
        </Text>
      </VStack>

      {/* <VStack
        gap={0}
        onMouseEnter={() => setIsFavouritesHovered(true)}
        onMouseLeave={() => setIsFavouritesHovered(false)}
        color={isFavouritesHovered ? "#CB809E" : "#728197"}
        cursor="pointer"
      >
        <Icon
          width="24px"
          height="24px"
          onClick={onOpen}
          aria-label="Call Sage"
          as={GoHeartFill}
        />
        <Text textAlign="center" fontSize="14px">
          Favourites
        </Text>
      </VStack> */}

      <VStack
        gap={0}
        onMouseEnter={() => setIsAccountHovered(true)}
        onMouseLeave={() => setIsAccountHovered(false)}
        cursor="pointer"
        onClick={() =>
          loggedIn ? navigate("/my-account") : navigate("/sign-in")
        }
      >
        <Icon
          width="24px"
          height="24px"
          onClick={onOpen}
          aria-label="Call Sage"
          color={isAccountHovered ? "#CB809E" : "#728197"}
          as={MdPerson}
        />
        <Text
          textAlign="center"
          fontSize="14px"
          color={isAccountHovered ? "#CB809E" : "#728197"}
        >
          {loggedIn ? "Account" : "Log In"}
        </Text>
      </VStack>
    </Stack>
  );
};

export default BottomNavigation;
